export function getValueFromInputElement(e, inputRefs) {
    const { name, value } = e.target;

    if (!inputRefs.current) return;

    if ( inputRefs.current[name] !== undefined) {
      inputRefs.current[name] = value;
    }
}